<template>
  <div class="mainRight pageContainer flexCloumn recommendPage">
    <el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
      <div class=""></div>
      <div class="flexEnd flex_1">
        <el-select v-model="job_id" filterable clearable placeholder="选择职位" size="small"
          style="width:130px;margin-left:10px">
          <el-option v-for="item in jobOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-cascader v-model="job_type" :props="{ value: 'id', label: 'type_name' }" :options="options" size="small"
          style="width:200px;margin-left: 10px" clearable placeholder="职位类型"></el-cascader>
        <el-button icon="el-icon-search" style="margin-left:10px" size="small" type="primary"
          @click="getList()">搜索</el-button>
      </div>
    </el-row>

    <el-row v-if="!tableData || tableData.length == 0" class="flexCenter" style="width:100%;padding:40px 15px;">
      <div style="text-align: center; color:#909399">
        <div>暂无推荐职位~</div>
      </div>
    </el-row>

    <div class="flex_1" style="width:100%;overflow-y:auto;padding:0 15px">
      <ul class="list-items">


        <li class="list-item flexCenter" v-for="(p, idx) in tableData" :key="idx">

          <div class="list-item-meta flexStart flex_1">
            <div class="list-item-meta-avatar">
              <span class="avatar-image flexCenter">
                <el-image fit="cover" style="width:100%;height:100%;" :src="p.photo ? p.photo : url"></el-image>
              </span>
              <div class="avatarBadgeContainer flexCenter">
                <img v-if="p.sex == 1" style="width:100%;height:100%;" src="../../../public/img/male.png" alt="">
                <img v-if="p.sex == 2" style="width:100%;height:100%;" src="../../../public/img/female.png" alt="">
              </div>

            </div>
            <div class="list-item-meta-content">
              <h4 class="list-item-meta-title">
                <a class="felxStart" href="javascript:;">{{ p.stu_name }}
                  <span v-if="p.job_arr && p.job_arr.length > 0" v-for="(job, idx_job) in p.job_arr"
                    style="margin: 0 8px; font-size: 14px;">
                    {{ job.job_type_name }}</span>
                </a>
              </h4>
              <div class="list-item-meta-description">
                <div class="flexStart">
                  <div v-if="p.job_arr && p.job_arr.length > 0">
                    <span>薪资:{{ p.job_arr[0].pay == 0 ? '面议' : (xzfw[p.job_arr[0].pay] || "-") }}</span>
                    <el-divider direction="vertical" />
                    <span>城市:{{ p.job_arr[0].cityName || CITY_DIC[p.job_arr[0].city]||'-' }}</span>
                    <el-divider direction="vertical" />
                  </div>
                  <span>学历:{{ xlyq[p.eduaction] || "-" }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="list-content">
            <div class="list-content-item">
              <p>{{ p.create_date.split(" ")[0] }} 发布</p>
            </div>
          </div>
          <ul class="list-item-action felxCloumn">
            <li>
              <div class="flexCenter">
                <el-tag v-if="p.invite_status == 0" size="mini" @click.stop="xiangqing(p)" type="primary"
                  style="cursor:pointer;">邀请简历</el-tag>
                <el-tag v-if="p.invite_status == 1" size="mini" @click.stop="xiangqing(p)" type="primary"
                  style="cursor:pointer;" plain>已邀请</el-tag>
              </div>
            </li>

          </ul>
        </li>
      </ul>
    </div>
    <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" :current-page="page.current_page"
      :page-size="page.per_page" :total="page.count" layout="total, sizes,prev, pager, next"
      :page-sizes="[10, 20, 50, 100]" style="margin: 10px 0 0 15px;">
    </el-pagination>

    <Detail v-if="dialogForm" pages="recommend" :formData="formData" :xlyq="xlyq" :xzfw="xzfw" :qzzt="qzzt"
      @touch="chakan"></Detail>
  </div>
</template>

<script>
import citys from "../../utils/arae_value.js";
import Detail from "./com/resumeDetail.vue";
import aes from '../../utils/aes.js'
import util from "@/utils/util";
export default {
  components: {
    Detail
  },
  data() {
    return {
      dialogForm: false,
      formData: {},
      job_type: [],
      job_id: "",
      page: {
        count: 0,
        current_page: 1,
        per_page: 20,
        total_page: 0
      },
      jobOptions: [],
      tableData: {},
      jobHtml: "",
      practiceHtml: "",
      projectHtml: "",
      tdzt: {},
      mszt: {},
      lyzt: {},
      xlyq: {},
      xzfw: {},
      qzzt: {},
      yqzt: {},
      options: [],
      url: "./img/img_avatar.png",
      srcList: [
        "./img/img_avatar.png"
      ],
      CITY_DIC:{}
    };
  },
  mounted() {
    let cityList = this.TreeToArrayFor(citys)
    let CITY_DIC = {}
    for (let i = 0, len = cityList.length; i < len; i++) {

      CITY_DIC[cityList[i].value] = cityList[i].label

    }
    this.CITY_DIC = CITY_DIC
    this.getComType().then(rr => {
      this.$http.post("/api/zp_job_list_select", {}).then(res => {
        this.jobOptions = res.data;
      });
      this.$http.post("/api/zp_job_type_tree", {}).then(res => {
        this.options = res.data.tree;
      });
      this.getList();
    });
  },
  methods: {
    /**
    * tree转数组，循环模式，每次增加循环的变量
    * 【注意：】只能使用for 循环，不能使用es6的迭代器
    * @param tree
    * @returns {{length}|*}
    * @constructor
    */
    TreeToArrayFor(tree) {
      if (!Array.isArray(tree) || !tree.length) throw new Error("请传入数组")
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].children) {
          // 每次children有值，就把值合并到原始数据tree上去，增加原始tree，for 循环 的长度也会增加 依次处理...
          tree = tree.concat(tree[i].children)
        }
      }
      return tree
    },
    getComType() {
      return new Promise(resolve => {
        this.$http
          .post("/api/sys_param_list", {
            param_type:
              "'TDZT','LYZT','MSZT','EDUACTION','SALARY_RANGE','QZZT','YQZT'",
            used: 0
          })
          .then(res => {
            let tdzt = {}; //投递状态
            let mszt = {}; //面试状态
            let lyzt = {}; //录用状态
            let xzfw = {}; //薪资类型
            let xlyq = {}; //学历类型
            let qzzt = {}; //求职状态
            let yqzt = {}; //邀请状态
            for (let item of res.data) {
              if (item.param_type == "TDZT") {
                tdzt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "SALARY_RANGE") {

                xzfw[item.param_value] = item.param_desc;
              }
              if (item.param_type == "EDUACTION") {

                xlyq[item.param_value] = item.param_desc;
              }
              if (item.param_type == "MSZT") {

                mszt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "LYZT") {

                lyzt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "QZZT") {

                qzzt[item.param_value] = item.param_desc;
              }
              if (item.param_type == "YQZT") {

                yqzt[item.param_value] = item.param_desc;
              }
            }
            this.tdzt = tdzt;
            this.mszt = mszt;
            this.lyzt = lyzt;
            this.xzfw = xzfw;
            this.xlyq = xlyq;
            this.qzzt = qzzt;
            this.yqzt = yqzt;
            resolve();
          });
      });
    },

    getList() {
      let _this = this
      const loading = this.$globalLoading()

      let data = {};
      data.job_type = this.job_type.length > 0 ? this.job_type[2] : '';
      data.page = this.page.current_page;
      data.pagesize = this.page.per_page;
      this.$http.post("/api/zp_job_info_yqlist", data).then(res => {

        let beforedata = res.data
        beforedata = aes.decrypt(beforedata).then(result => {
          if (result && _this.isJSON(result)) {
            let finalData = JSON.parse(result)
            console.log(210, finalData)
            if (finalData && finalData.data) {
              finalData.data.map(a => {
                let obj = _this.getParentId(citys, a.city);
                a.cityName = obj ? obj.label : '';
                if (a.job_arr&&a.job_arr.length>0) {
                  a.job_arr.map(job => {
                    if (job.city) {
                      console.log(221, job.city)
                      let areaNames = util.getParentAreaByValue(citys, job.city)
                      console.log(223, areaNames)
                      if (areaNames && areaNames.length > 0) {
                        job.cityName = areaNames.map(a => a.label).reverse().join('/');
                      }
                    }
                  })
                }
              });
              _this.tableData = finalData.data;
              _this.page = finalData.page;
            }
          }
        })
        loading.close()
      });
    },
    getParentId(list, iid) {
      if (list && list.length > 0) {
        for (let o of list) {
          if (o.value == iid) return o;
          const o_ = this.getParentId(o.children, iid);
          if (o_) return o_;
        }
      }
    },

    canParseToJson(str, parseFlag) {
      try {
        if (typeof JSON.parse(str) === "object" && ((Object.prototype.toString.call(JSON.parse(str)) === "[object Object]") ||
          (Object.prototype.toString.call(JSON.parse(str)) === "[object Array]"))) {
          return parseFlag === true ? JSON.parse(str) : true
        }
      } catch (e) { }
      return false
    },
    xiangqing(row) {
      let _this = this
      this.$http.post("/api/zp_resume_info", { id: row.stu_id }).then(res => {
        // this.$http.post("/api/zp_resume_info", { id: 5003 }).then(res => {
        let beforedata = res.data
        beforedata = aes.decrypt(beforedata).then(result => {
          if (result && _this.isJSON(result)) {
            let finalData = JSON.parse(result)
            // console.log(210, finalData)
            if (finalData) {
              res.data = finalData

              if (!res.data.tel) {
                res.data.tel = '***********'
              } else {
                res.data.tel = '***********'
              }

              if (!res.data.wechat) {
                res.data.wechat = '***********'
              } else {
                res.data.wechat = '***********'

              }

              if (res.data.award_annex && this.canParseToJson(res.data.award_annex)) {
                res.data.award_annex = JSON.parse(res.data.award_annex)
              }
              if (res.data.job_array) {
                res.data.job_array.map(a => {
                  let obj = this.getParentId(citys, a.city);
                  a.cityName = obj ? obj.label : '';
                });
              }
              if (res.data.practice && this.canParseToJson(res.data.practice)) {
                res.data.practice = JSON.parse(res.data.practice)
              }
              if (res.data.project && this.canParseToJson(res.data.project)) {
                res.data.project = JSON.parse(res.data.project)
                res.data.project.map(a => {
                  if (a.annex && this.canParseToJson(a.annex)) {
                    a.annex = JSON.parse(a.annex)
                  }
                })
              }

              this.formData = res.data;
              this.dialogForm = true;
            }
          }
        })
        return
        this.jobHtml = "";
        this.practiceHtml = "";
        this.projectHtml = "";
        this.formData.job_array.forEach(info => {
          let obj = this.getParentId(citys, info.city);
          this.jobHtml +=
            "<span>&nbsp;&nbsp;" +
            info.type_name +
            "&nbsp;&nbsp;|&nbsp;&nbsp;" +
            this.xzfw[info.pay].param_desc +
            "&nbsp;&nbsp;|&nbsp;&nbsp;" +
            obj.label +
            "<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        });
        JSON.parse(this.formData.practice).forEach(info1 => {
          this.practiceHtml += `<span>&nbsp;&nbsp;公司名称 : &nbsp;${info1.enterName}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>&nbsp;&nbsp;起止时间 : &nbsp;${info1.startDate}&nbsp;-&nbsp;${info1.endDate}</span> </br>
        <span>&nbsp;&nbsp;所属行业 : &nbsp;${info1.industry_name}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>&nbsp;&nbsp;职位类型 : &nbsp;${info1.job_type_name}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>&nbsp;&nbsp;所属部门 : &nbsp;${info1.dept}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span>&nbsp;&nbsp;工作内容 : &nbsp;${info1.perfor}</span> </br>
        <span>&nbsp;&nbsp;工作业绩 : &nbsp;${info1.jobContent}</span> </br></br>`;
        });
        JSON.parse(this.formData.project).forEach(info2 => {
          this.projectHtml += `<span>&nbsp;&nbsp;项目名称:&nbsp;${info2.name}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span>&nbsp;&nbsp;起止时间 : &nbsp;${info2.startDate}&nbsp;-&nbsp;${info2.endDate}</span> </br>
         <span>&nbsp;&nbsp;项目描述 : &nbsp;${info2.projDesc}</span></br>
        <span>&nbsp;&nbsp;担任角色 : &nbsp;${info2.role}</span></br>`;
          if (info2.annex.length > 0) {
            this.projectHtml += ` <span>&nbsp;&nbsp;项目附件 : &nbsp;`;
            JSON.parse(info2.annex).forEach(info3 => {
              this.projectHtml += `<a href="${info3.fileUrl}">${info3.fileName}</a></br>`;
            });
            this.projectHtml += `</span></br></br>`;
          } else {
            this.projectHtml += `</br>`;
          }
        });
        this.dialogForm = true;
      });
    },

    openAnnexResume(url) {
      window.open(url)
    },
    handlePageChange(page) {
      this.page.current_page = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.current_page = 1;
      this.page.per_page = val;
      this.getList(1)
    },
    chakan(row) {
      if (!this.job_id) {
        this.$message({
          type: "error",
          message: "请先选择职位!"
        });
        return false;
      }
      this.$http
        .post("/api/zp_gwyq_edit", {
          job_id: this.job_id,
          resume_id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: `职位邀请成功!`
          });
          this.dialogForm = false
          this.getList();
        });
    }
  }
};
</script>

<style scoped lang="less">
.pageContainer {
  /deep/ .box-card {
    margin-bottom: 12px;
    padding: 24px 10px 24px 30px;
  }

  /deep/ .el-card__body {
    padding: 0px;
  }

}

.recommendPage {

  ul,
  li {
    list-style: none;

    outline: none;
  }

  .list-items {
    width: 100%;
    margin: 5px 0 0 0;
    padding: 0;
    list-style: none;

    outline: none;

    .list-item {

      background-color: #fff;
      padding: 24px !important;
      border: 0;
      margin-bottom: 12px;
      outline: none;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

      .list-item-meta {
        align-items: center;

        .list-item-meta-avatar {
          position: relative;
          margin-right: 16px;

          span {
            width: 52px;
            height: 52px;
            line-height: 52px;
            border-radius: 50%;
            margin: 0;
            padding: 0;
            font-size: 14px;
            font-variant: tabular-nums;
            list-style: none;
            font-feature-settings: 'tnum';
            position: relative;
            display: inline-block;
            overflow: hidden;
            color: #fff;
            white-space: nowrap;
            text-align: center;
            vertical-align: middle;
          }

          .avatarBadgeContainer {
            position: absolute;
            top: 0;
            right: 0;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            /* border: 1px solid #fff; */
            overflow: hidden;
            background-color: #fff;
          }
        }

        .list-item-meta-content {
          -webkit-box-flex: 1;
          flex: 1 0;

          .list-item-meta-title {
            font-size: 18px;
            margin-top: 0;
            margin-bottom: 17px;
            color: #000000a6;
            line-height: 22px;
            font-weight: 500;

            a {
              font-size: 18px;
              color: #000000a6;
              -webkit-transition: all 0.3s;
              transition: all 0.3s;
              touch-action: manipulation;
              background-color: transparent;
              cursor: pointer;
              text-decoration: none;
              outline: none;
            }
          }

          .list-item-meta-description {
            color: rgba(0, 0, 0, 0.45);
            font-size: 14px;
            line-height: 22px;

            span {
              font-size: 14px;
              color: rgb(48, 49, 51);
            }
          }
        }

      }

      .list-content {
        .list-content-item {
          color: rgba(0, 0, 0, 0.45);
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          margin-left: 40px;

          p {
            margin-top: 4px;
            margin-bottom: 0;
            line-height: 22px;
          }
        }
      }

      .list-item-action {
        flex: 0 0 auto;
        margin-left: 48px;
        padding: 0;
        font-size: 0;
        list-style: none;
      }
    }
  }

  .cus_dialog {

    div {
      box-sizing: border-box;
    }

    .rowContainer {
      width: 100%;

      .item-userinfo {
        margin-top: 32px;

        .color30 {
          color: #303133;
        }

        .color60 {
          color: #606266;
        }

        .fontWeight500 {
          font-weight: 700;
        }

        .left {
          width: 100px;
        }

        .right {
          margin-left: 32px;

          .userName {
            font-size: 18px;
            color: #303133;
            font-weight: 500;
            margin-right: 4px;
          }

          .contact {
            margin-top: 8px;
          }

          .timestamp {
            color: #909399;
            font-size: 12px;
          }

          .commonText {
            margin-top: 8px;
          }

          .annexResume {
            margin-top: 8px;
            color: #3378fa;
            cursor: pointer;
          }

          .item-att {
            margin-left: 8px;
            color: #3378fa;
            cursor: pointer;
          }
        }
      }

      .item-userinfo:first-of-type {
        margin-top: 0;
      }

      .subitem-userinfo {
        margin-top: 16px;
        color: #606266;
      }

      .crumbImg {
        width: 100%;

        .thumbnail {
          display: inline-block;
          width: 20%;

          img {
            display: inline-block;
            width: 100%;
          }
        }
      }
    }

    .avatarContainer {
      flex: 0 1 68px;

      &>span {
        border-radius: 68px;
        display: block;
        width: 68px;
        height: 68px;
        line-height: 68px;
      }

      .ant-avatar.ant-avatar-icon {
        font-size: 40px;
      }

      img {
        display: inline-block;
        width: 68px;
        height: 68px;
        border-radius: 50%;
      }
    }

    .right {
      .ant-divider-vertical {
        margin: 0 16px;
      }
    }



  }
}
</style>
